import { render, staticRenderFns } from "./roleUserList.vue?vue&type=template&id=d72026e2&scoped=true&"
import script from "./roleUserList.vue?vue&type=script&lang=js&"
export * from "./roleUserList.vue?vue&type=script&lang=js&"
import style0 from "./roleUserList.vue?vue&type=style&index=0&id=d72026e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72026e2",
  null
  
)

component.options.__file = "roleUserList.vue"
export default component.exports